import React from "react";

function index() {
  return <div>StudentsEnrolled</div>;
}

export default index;
